import { request, cachedRequest } from './client'

// Terminals
export interface Terminal {
  id: number
  name: string
  country: string | null
  type: string | null
  status: string | null
  capacity_mtpa: number | null
  operator: string | null
  owner: string | null
  parent: string | null
  lat: number | null
  lng: number | null
  region: string | null
  sub_region: string | null
  floating: string | null
  start_year: number | null
}

export interface TerminalStats {
  total: number
  by_status: Record<string, number>
  by_type: Record<string, number>
  total_capacity_mtpa: number
  countries: number
}

const TERMINAL_TTL = 10 * 60 * 1000 // 10 minutes

export const terminals = {
  list: (params?: Record<string, string>) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return cachedRequest<Terminal[]>(`/terminals${qs}`, undefined, TERMINAL_TTL)
  },
  stats: () => cachedRequest<TerminalStats>('/terminals/stats', undefined, TERMINAL_TTL),
  get: (id: number) => request<Terminal>(`/terminals/${id}`),
}

// Carriers
export interface Carrier {
  id: number
  imo: string | null
  name: string
  status: string | null
  owner: string | null
  owner_country: string | null
  builder: string | null
  builder_country: string | null
  capacity: number | null
  capacity_unit: string | null
  cargo_type: string | null
  vessel_type: string | null
  propulsion: string | null
  delivery_year: number | null
}

export interface CarrierStats {
  total: number
  active: number
  on_order: number
  total_capacity: number
  on_order_capacity: number
  by_propulsion: Record<string, number>
  top_owners: { name: string; count: number }[]
  top_builders: { name: string; count: number }[]
  deliveries_by_year: Record<string, number>
}

const CARRIER_TTL = 5 * 60 * 1000 // 5 minutes

export const carriers = {
  list: (params?: Record<string, string>) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return cachedRequest<Carrier[]>(`/carriers${qs}`, undefined, CARRIER_TTL)
  },
  myVessels: () => cachedRequest<Carrier[]>('/carriers/my-vessels', undefined, CARRIER_TTL),
  stats: () => cachedRequest<CarrierStats>('/carriers/stats', undefined, CARRIER_TTL),
  get: (id: number) => request<Carrier>(`/carriers/${id}`),
}
